interface DownloadEnvironment {
  readonly createObjectUrl: (blob: Blob) => string;
  readonly revokeObjectUrl: (url: string) => void;
  readonly createAnchor: () => HTMLAnchorElement;
  readonly scheduleCleanup: (cleanup: () => void) => void;
}

const browserEnvironment: DownloadEnvironment = {
  createObjectUrl: (blob) => URL.createObjectURL(blob),
  revokeObjectUrl: (url) => URL.revokeObjectURL(url),
  createAnchor: () => document.createElement("a"),
  scheduleCleanup: (cleanup) => window.setTimeout(cleanup, 0),
};

/** Starts one explicit local download and schedules object-URL cleanup. */
export function downloadBlob(
  blob: Blob,
  filename: string,
  environment: DownloadEnvironment = browserEnvironment,
): void {
  const objectUrl = environment.createObjectUrl(blob);
  const anchor = environment.createAnchor();
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.rel = "noopener";
  anchor.click();
  environment.scheduleCleanup(() => environment.revokeObjectUrl(objectUrl));
}
